export const mediaConstants = {
    FILE_UPLOAD: 'FILE_MEDIA_UPLOAD_REQUEST',
    GET_ALL_REQUEST: 'MEDIA_GET_ALL_REQUEST',
    EDIT_REQUEST: 'MEDIA_EDIT_REQUEST',
    DELETE_REQUEST: 'MEDIA_DELETE_REQUEST',
    LOADING_REQUEST: 'MEDIA_LOADING_REQUEST'
};